module.exports = __webpack_public_path__ + "static/media/terrace-5.245f4f85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/terrace-5.jpg
// module id = 72
// module chunks = 0